export default function getRegionList(country){
    return REGION_LIST_PER_COUNTRY.hasOwnProperty(country) ? REGION_LIST_PER_COUNTRY[country] : []
}

const REGION_LIST_PER_COUNTRY= {
    "AT": [
        {
            "id": "Burgenland",
            "value": "Burgenland"
        },
        {
            "id": "Kärnten",
            "value": "Kärnten"
        },
        {
            "id": "Niederösterreich",
            "value": "Niederösterreich"
        },
        {
            "id": "Oberösterreich",
            "value": "Oberösterreich"
        },
        {
            "id": "Salzburg",
            "value": "Salzburg"
        },
        {
            "id": "Steiermark",
            "value": "Steiermark"
        },
        {
            "id": "Tirol",
            "value": "Tirol"
        },
        {
            "id": "Vorarlberg",
            "value": "Vorarlberg"
        },
        {
            "id": "Wien",
            "value": "Wien"
        }
    ],
    "FR": [
        {
            "id": "Auvergne-Rhône-Alpes",
            "value": "Auvergne-Rhône-Alpes"
        },
        {
            "id": "Bourgogne-Franche-Comté",
            "value": "Bourgogne-Franche-Comté"
        },
        {
            "id": "Bretagne",
            "value": "Bretagne"
        },
        {
            "id": "Centre-Val de Loire",
            "value": "Centre-Val de Loire"
        },
        {
            "id": "Corse",
            "value": "Corse"
        },
        {
            "id": "Grand Est",
            "value": "Grand Est"
        },
        {
            "id": "Hauts-de-France",
            "value": "Hauts-de-France"
        },
        {
            "id": "Île-de-France",
            "value": "Île-de-France"
        },
        {
            "id": "Normandie",
            "value": "Normandie"
        },
        {
            "id": "Nouvelle-Aquitaine",
            "value": "Nouvelle-Aquitaine"
        },
        {
            "id": "Occitanie",
            "value": "Occitanie"
        },
        {
            "id": "Pays de la Loire",
            "value": "Pays de la Loire"
        },
        {
            "id": "Provence-Alpes-Cote d'Azur",
            "value": "Provence-Alpes-Cote d'Azur"
        },
        {
            "id": "Clipperton",
            "value": "Clipperton"
        },
        {
            "id": "Guadeloupe",
            "value": "Guadeloupe"
        },
        {
            "id": "Guyane",
            "value": "Guyane"
        },
        {
            "id": "Martinique",
            "value": "Martinique"
        },
        {
            "id": "Mayotte",
            "value": "Mayotte"
        },
        {
            "id": "Novelle-Calédonie",
            "value": "Novelle-Calédonie"
        },
        {
            "id": "Polynésie",
            "value": "Polynésie"
        },
        {
            "id": "Saint-Pierre-et-Miquelon",
            "value": "Saint-Pierre-et-Miquelon"
        },
        {
            "id": "Saint Barthélemy",
            "value": "Saint Barthélemy"
        },
        {
            "id": "Saint Martin",
            "value": "Saint Martin"
        },
        {
            "id": "Réunion",
            "value": "Réunion"
        },
        {
            "id": "Terres Australes Françaises",
            "value": "Terres Australes Françaises"
        },
        {
            "id": "Wallis-et-Futuna",
            "value": "Wallis-et-Futuna"
        }
    ],
    "DE": [
        {
            "id": "Baden-Württemberg",
            "value": "Baden-Württemberg"
        },
        {
            "id": "Bayern",
            "value": "Bayern"
        },
        {
            "id": "Berlin",
            "value": "Berlin"
        },
        {
            "id": "Brandenburg",
            "value": "Brandenburg"
        },
        {
            "id": "Bremen",
            "value": "Bremen"
        },
        {
            "id": "Hamburg",
            "value": "Hamburg"
        },
        {
            "id": "Hessen",
            "value": "Hessen"
        },
        {
            "id": "Mecklenburg-Vorpommern",
            "value": "Mecklenburg-Vorpommern"
        },
        {
            "id": "Niedersachsen",
            "value": "Niedersachsen"
        },
        {
            "id": "Nordrhein-Westfalen",
            "value": "Nordrhein-Westfalen"
        },
        {
            "id": "Rheinland-Pfalz",
            "value": "Rheinland-Pfalz"
        },
        {
            "id": "Saarland",
            "value": "Saarland"
        },
        {
            "id": "Sachsen",
            "value": "Sachsen"
        },
        {
            "id": "Sachsen-Anhalt",
            "value": "Sachsen-Anhalt"
        },
        {
            "id": "Schleswig-Holstein",
            "value": "Schleswig-Holstein"
        },
        {
            "id": "Thüringen",
            "value": "Thüringen"
        }
    ],
    "NL": [
        {
            "id": "Drenthe",
            "value": "Drenthe"
        },
        {
            "id": "Flevoland",
            "value": "Flevoland"
        },
        {
            "id": "Friesland",
            "value": "Friesland"
        },
        {
            "id": "Gelderland",
            "value": "Gelderland"
        },
        {
            "id": "Groningen",
            "value": "Groningen"
        },
        {
            "id": "Limburg",
            "value": "Limburg"
        },
        {
            "id": "Noord-Brabant",
            "value": "Noord-Brabant"
        },
        {
            "id": "Noord-Holland",
            "value": "Noord-Holland"
        },
        {
            "id": "Overijssel",
            "value": "Overijssel"
        },
        {
            "id": "Utrecht",
            "value": "Utrecht"
        },
        {
            "id": "Zeeland",
            "value": "Zeeland"
        },
        {
            "id": "Zuid-Holland",
            "value": "Zuid-Holland"
        }
    ],
    "ES": [
        {
            "id": "Albacete",
            "value": "Albacete"
        },
        {
            "id": "Alicante",
            "value": "Alicante"
        },
        {
            "id": "Almería",
            "value": "Almería"
        },
        {
            "id": "Araba/Álava",
            "value": "Araba/Álava"
        },
        {
            "id": "Asturias",
            "value": "Asturias"
        },
        {
            "id": "Ávila",
            "value": "Ávila"
        },
        {
            "id": "Badajoz",
            "value": "Badajoz"
        },
        {
            "id": "Barcelona",
            "value": "Barcelona"
        },
        {
            "id": "Bizkaia",
            "value": "Bizkaia"
        },
        {
            "id": "Burgos",
            "value": "Burgos"
        },
        {
            "id": "Cáceres",
            "value": "Cáceres"
        },
        {
            "id": "Cádiz",
            "value": "Cádiz"
        },
        {
            "id": "Cantabria",
            "value": "Cantabria"
        },
        {
            "id": "Castellón/Castelló",
            "value": "Castellón/Castelló"
        },
        {
            "id": "Ceuta",
            "value": "Ceuta"
        },
        {
            "id": "Ciudad Real",
            "value": "Ciudad Real"
        },
        {
            "id": "Córdoba",
            "value": "Córdoba"
        },
        {
            "id": "A Coruña",
            "value": "A Coruña"
        },
        {
            "id": "Cuenca",
            "value": "Cuenca"
        },
        {
            "id": "Gipuzkoa",
            "value": "Gipuzkoa"
        },
        {
            "id": "Girona",
            "value": "Girona"
        },
        {
            "id": "Granada",
            "value": "Granada"
        },
        {
            "id": "Guadalajara",
            "value": "Guadalajara"
        },
        {
            "id": "Huelva",
            "value": "Huelva"
        },
        {
            "id": "Huesca",
            "value": "Huesca"
        },
        {
            "id": "Illes Balears",
            "value": "Illes Balears"
        },
        {
            "id": "Jaén",
            "value": "Jaén"
        },
        {
            "id": "León",
            "value": "León"
        },
        {
            "id": "Lleida",
            "value": "Lleida"
        },
        {
            "id": "Lugo",
            "value": "Lugo"
        },
        {
            "id": "Madrid",
            "value": "Madrid"
        },
        {
            "id": "Málaga",
            "value": "Málaga"
        },
        {
            "id": "Melilla",
            "value": "Melilla"
        },
        {
            "id": "Murcia",
            "value": "Murcia"
        },
        {
            "id": "Navarra/Nafarroa",
            "value": "Navarra/Nafarroa"
        },
        {
            "id": "Ourense",
            "value": "Ourense"
        },
        {
            "id": "Palencia",
            "value": "Palencia"
        },
        {
            "id": "Las Palmas",
            "value": "Las Palmas"
        },
        {
            "id": "Pontevedra",
            "value": "Pontevedra"
        },
        {
            "id": "La Rioja",
            "value": "La Rioja"
        },
        {
            "id": "Salamanca",
            "value": "Salamanca"
        },
        {
            "id": "Santa Cruz de Tenerife",
            "value": "Santa Cruz de Tenerife"
        },
        {
            "id": "Segovia",
            "value": "Segovia"
        },
        {
            "id": "Sevilla",
            "value": "Sevilla"
        },
        {
            "id": "Soria",
            "value": "Soria"
        },
        {
            "id": "Tarragona",
            "value": "Tarragona"
        },
        {
            "id": "Teruel",
            "value": "Teruel"
        },
        {
            "id": "Toledo",
            "value": "Toledo"
        },
        {
            "id": "Valencia/València",
            "value": "Valencia/València"
        },
        {
            "id": "Valladolid",
            "value": "Valladolid"
        },
        {
            "id": "Zamora",
            "value": "Zamora"
        },
        {
            "id": "Zaragoza",
            "value": "Zaragoza"
        }
    ],
    "SE": [
        {
            "id": "Blekinge",
            "value": "Blekinge"
        },
        {
            "id": "Dalarna",
            "value": "Dalarna"
        },
        {
            "id": "Gävleborg",
            "value": "Gävleborg"
        },
        {
            "id": "Gotland",
            "value": "Gotland"
        },
        {
            "id": "Halland",
            "value": "Halland"
        },
        {
            "id": "Jämtland",
            "value": "Jämtland"
        },
        {
            "id": "Jönköping",
            "value": "Jönköping"
        },
        {
            "id": "Kalmar",
            "value": "Kalmar"
        },
        {
            "id": "Kronoberg",
            "value": "Kronoberg"
        },
        {
            "id": "Norrbotten",
            "value": "Norrbotten"
        },
        {
            "id": "Örebro",
            "value": "Örebro"
        },
        {
            "id": "Östergötland",
            "value": "Östergötland"
        },
        {
            "id": "Skåne",
            "value": "Skåne"
        },
        {
            "id": "Södermanland",
            "value": "Södermanland"
        },
        {
            "id": "Stockholm",
            "value": "Stockholm"
        },
        {
            "id": "Uppsala",
            "value": "Uppsala"
        },
        {
            "id": "Värmland",
            "value": "Värmland"
        },
        {
            "id": "Västerbotten",
            "value": "Västerbotten"
        },
        {
            "id": "Västernorrland",
            "value": "Västernorrland"
        },
        {
            "id": "Västmanland",
            "value": "Västmanland"
        },
        {
            "id": "Västra Götaland",
            "value": "Västra Götaland"
        }
    ],
    "CH": [
        {
            "id": "Aargau",
            "value": "Aargau"
        },
        {
            "id": "Appenzell Ausserrhoden",
            "value": "Appenzell Ausserrhoden"
        },
        {
            "id": "Appenzell Innerhoden",
            "value": "Appenzell Innerhoden"
        },
        {
            "id": "Basel-Landschaft",
            "value": "Basel-Landschaft"
        },
        {
            "id": "Basel-Stadt",
            "value": "Basel-Stadt"
        },
        {
            "id": "Bern",
            "value": "Bern"
        },
        {
            "id": "Fribourg",
            "value": "Fribourg"
        },
        {
            "id": "Genève",
            "value": "Genève"
        },
        {
            "id": "Glarus",
            "value": "Glarus"
        },
        {
            "id": "Graubünden",
            "value": "Graubünden"
        },
        {
            "id": "Jura",
            "value": "Jura"
        },
        {
            "id": "Luzern",
            "value": "Luzern"
        },
        {
            "id": "Neuchâtel",
            "value": "Neuchâtel"
        },
        {
            "id": "Nidwalden",
            "value": "Nidwalden"
        },
        {
            "id": "Obwalden",
            "value": "Obwalden"
        },
        {
            "id": "Sankt Gallen",
            "value": "Sankt Gallen"
        },
        {
            "id": "Schaffhausen",
            "value": "Schaffhausen"
        },
        {
            "id": "Schwyz",
            "value": "Schwyz"
        },
        {
            "id": "Solothurn",
            "value": "Solothurn"
        },
        {
            "id": "Thurgau",
            "value": "Thurgau"
        },
        {
            "id": "Ticino",
            "value": "Ticino"
        },
        {
            "id": "Uri",
            "value": "Uri"
        },
        {
            "id": "Valais",
            "value": "Valais"
        },
        {
            "id": "Vaud",
            "value": "Vaud"
        },
        {
            "id": "Zug",
            "value": "Zug"
        },
        {
            "id": "Zürich",
            "value": "Zürich"
        }
    ],
    "GB": [
        {
            "id": "Aberdeen City",
            "value": "Aberdeen City"
        },
        {
            "id": "Aberdeenshire",
            "value": "Aberdeenshire"
        },
        {
            "id": "Angus",
            "value": "Angus"
        },
        {
            "id": "Antrim and Newtownabbey",
            "value": "Antrim and Newtownabbey"
        },
        {
            "id": "Ards and North Down",
            "value": "Ards and North Down"
        },
        {
            "id": "Argyll and Bute",
            "value": "Argyll and Bute"
        },
        {
            "id": "Armagh, Banbridge and Craigavon",
            "value": "Armagh, Banbridge and Craigavon"
        },
        {
            "id": "Barking and Dagenham",
            "value": "Barking and Dagenham"
        },
        {
            "id": "Barnet",
            "value": "Barnet"
        },
        {
            "id": "Barnsley",
            "value": "Barnsley"
        },
        {
            "id": "Bath and North East Somerset",
            "value": "Bath and North East Somerset"
        },
        {
            "id": "Bedford",
            "value": "Bedford"
        },
        {
            "id": "Belfast",
            "value": "Belfast"
        },
        {
            "id": "Bexley",
            "value": "Bexley"
        },
        {
            "id": "Birmingham",
            "value": "Birmingham"
        },
        {
            "id": "Blackburn with Darwen",
            "value": "Blackburn with Darwen"
        },
        {
            "id": "Blackpool",
            "value": "Blackpool"
        },
        {
            "id": "Blaenau Gwent",
            "value": "Blaenau Gwent"
        },
        {
            "id": "Bolton",
            "value": "Bolton"
        },
        {
            "id": "Bournemouth",
            "value": "Bournemouth"
        },
        {
            "id": "Bracknell Forest",
            "value": "Bracknell Forest"
        },
        {
            "id": "Bradford",
            "value": "Bradford"
        },
        {
            "id": "Brent",
            "value": "Brent"
        },
        {
            "id": "Bridgend",
            "value": "Bridgend"
        },
        {
            "id": "Brighton and Hove",
            "value": "Brighton and Hove"
        },
        {
            "id": "Bristol, City of",
            "value": "Bristol, City of"
        },
        {
            "id": "Bromley",
            "value": "Bromley"
        },
        {
            "id": "Buckinghamshire",
            "value": "Buckinghamshire"
        },
        {
            "id": "Bury",
            "value": "Bury"
        },
        {
            "id": "Caerphilly",
            "value": "Caerphilly"
        },
        {
            "id": "Calderdale",
            "value": "Calderdale"
        },
        {
            "id": "Cambridgeshire",
            "value": "Cambridgeshire"
        },
        {
            "id": "Camden",
            "value": "Camden"
        },
        {
            "id": "Cardiff",
            "value": "Cardiff"
        },
        {
            "id": "Carmarthenshire",
            "value": "Carmarthenshire"
        },
        {
            "id": "Causeway Coast and Glens",
            "value": "Causeway Coast and Glens"
        },
        {
            "id": "Central Bedfordshire",
            "value": "Central Bedfordshire"
        },
        {
            "id": "Ceredigion",
            "value": "Ceredigion"
        },
        {
            "id": "Cheshire East",
            "value": "Cheshire East"
        },
        {
            "id": "Cheshire West and Chester",
            "value": "Cheshire West and Chester"
        },
        {
            "id": "Clackmannanshire",
            "value": "Clackmannanshire"
        },
        {
            "id": "Conwy",
            "value": "Conwy"
        },
        {
            "id": "Cornwall",
            "value": "Cornwall"
        },
        {
            "id": "Coventry",
            "value": "Coventry"
        },
        {
            "id": "Croydon",
            "value": "Croydon"
        },
        {
            "id": "Cumbria",
            "value": "Cumbria"
        },
        {
            "id": "Darlington",
            "value": "Darlington"
        },
        {
            "id": "Denbighshire",
            "value": "Denbighshire"
        },
        {
            "id": "Derby",
            "value": "Derby"
        },
        {
            "id": "Derbyshire",
            "value": "Derbyshire"
        },
        {
            "id": "Derry and Strabane",
            "value": "Derry and Strabane"
        },
        {
            "id": "Devon",
            "value": "Devon"
        },
        {
            "id": "Doncaster",
            "value": "Doncaster"
        },
        {
            "id": "Dorset",
            "value": "Dorset"
        },
        {
            "id": "Dudley",
            "value": "Dudley"
        },
        {
            "id": "Dumfries and Galloway",
            "value": "Dumfries and Galloway"
        },
        {
            "id": "Dundee City",
            "value": "Dundee City"
        },
        {
            "id": "Durham County",
            "value": "Durham County"
        },
        {
            "id": "Ealing",
            "value": "Ealing"
        },
        {
            "id": "East Ayrshire",
            "value": "East Ayrshire"
        },
        {
            "id": "East Dunbartonshire",
            "value": "East Dunbartonshire"
        },
        {
            "id": "East Lothian",
            "value": "East Lothian"
        },
        {
            "id": "East Renfrewshire",
            "value": "East Renfrewshire"
        },
        {
            "id": "East Riding of Yorkshire",
            "value": "East Riding of Yorkshire"
        },
        {
            "id": "East Sussex",
            "value": "East Sussex"
        },
        {
            "id": "Edinburgh, City of",
            "value": "Edinburgh, City of"
        },
        {
            "id": "Eilean Siar",
            "value": "Eilean Siar"
        },
        {
            "id": "Enfield",
            "value": "Enfield"
        },
        {
            "id": "Essex",
            "value": "Essex"
        },
        {
            "id": "Falkirk",
            "value": "Falkirk"
        },
        {
            "id": "Fermanagh and Omagh",
            "value": "Fermanagh and Omagh"
        },
        {
            "id": "Fife",
            "value": "Fife"
        },
        {
            "id": "Flintshire",
            "value": "Flintshire"
        },
        {
            "id": "Gateshead",
            "value": "Gateshead"
        },
        {
            "id": "Glasgow City",
            "value": "Glasgow City"
        },
        {
            "id": "Gloucestershire",
            "value": "Gloucestershire"
        },
        {
            "id": "Greenwich",
            "value": "Greenwich"
        },
        {
            "id": "Gwynedd",
            "value": "Gwynedd"
        },
        {
            "id": "Hackney",
            "value": "Hackney"
        },
        {
            "id": "Halton",
            "value": "Halton"
        },
        {
            "id": "Hammersmith and Fulham",
            "value": "Hammersmith and Fulham"
        },
        {
            "id": "Hampshire",
            "value": "Hampshire"
        },
        {
            "id": "Haringey",
            "value": "Haringey"
        },
        {
            "id": "Harrow",
            "value": "Harrow"
        },
        {
            "id": "Hartlepool",
            "value": "Hartlepool"
        },
        {
            "id": "Havering",
            "value": "Havering"
        },
        {
            "id": "Herefordshire",
            "value": "Herefordshire"
        },
        {
            "id": "Hertfordshire",
            "value": "Hertfordshire"
        },
        {
            "id": "Highland",
            "value": "Highland"
        },
        {
            "id": "Hillingdon",
            "value": "Hillingdon"
        },
        {
            "id": "Hounslow",
            "value": "Hounslow"
        },
        {
            "id": "Inverclyde",
            "value": "Inverclyde"
        },
        {
            "id": "Isle of Anglesey",
            "value": "Isle of Anglesey"
        },
        {
            "id": "Isle of Wight",
            "value": "Isle of Wight"
        },
        {
            "id": "Isles of Scilly",
            "value": "Isles of Scilly"
        },
        {
            "id": "Islington",
            "value": "Islington"
        },
        {
            "id": "Kensington and Chelsea",
            "value": "Kensington and Chelsea"
        },
        {
            "id": "Kent",
            "value": "Kent"
        },
        {
            "id": "Kingston upon Hull",
            "value": "Kingston upon Hull"
        },
        {
            "id": "Kingston upon Thames",
            "value": "Kingston upon Thames"
        },
        {
            "id": "Kirklees",
            "value": "Kirklees"
        },
        {
            "id": "Knowsley",
            "value": "Knowsley"
        },
        {
            "id": "Lambeth",
            "value": "Lambeth"
        },
        {
            "id": "Lancashire",
            "value": "Lancashire"
        },
        {
            "id": "Leeds",
            "value": "Leeds"
        },
        {
            "id": "Leicester",
            "value": "Leicester"
        },
        {
            "id": "Leicestershire",
            "value": "Leicestershire"
        },
        {
            "id": "Lewisham",
            "value": "Lewisham"
        },
        {
            "id": "Lincolnshire",
            "value": "Lincolnshire"
        },
        {
            "id": "Lisburn and Castlereagh",
            "value": "Lisburn and Castlereagh"
        },
        {
            "id": "Liverpool",
            "value": "Liverpool"
        },
        {
            "id": "London, City of",
            "value": "London, City of"
        },
        {
            "id": "Luton",
            "value": "Luton"
        },
        {
            "id": "Manchester",
            "value": "Manchester"
        },
        {
            "id": "Medway",
            "value": "Medway"
        },
        {
            "id": "Merthyr Tydfil",
            "value": "Merthyr Tydfil"
        },
        {
            "id": "Merton",
            "value": "Merton"
        },
        {
            "id": "Mid and East Antrim",
            "value": "Mid and East Antrim"
        },
        {
            "id": "Mid Ulster",
            "value": "Mid Ulster"
        },
        {
            "id": "Middlesbrough",
            "value": "Middlesbrough"
        },
        {
            "id": "Midlothian",
            "value": "Midlothian"
        },
        {
            "id": "Milton Keynes",
            "value": "Milton Keynes"
        },
        {
            "id": "Monmouthshire",
            "value": "Monmouthshire"
        },
        {
            "id": "Moray",
            "value": "Moray"
        },
        {
            "id": "Neath Port Talbot",
            "value": "Neath Port Talbot"
        },
        {
            "id": "Newcastle upon Tyne",
            "value": "Newcastle upon Tyne"
        },
        {
            "id": "Newham",
            "value": "Newham"
        },
        {
            "id": "Newport",
            "value": "Newport"
        },
        {
            "id": "Newry, Mourne and Down",
            "value": "Newry, Mourne and Down"
        },
        {
            "id": "Norfolk",
            "value": "Norfolk"
        },
        {
            "id": "North Ayrshire",
            "value": "North Ayrshire"
        },
        {
            "id": "North East Lincolnshire",
            "value": "North East Lincolnshire"
        },
        {
            "id": "North Lanarkshire",
            "value": "North Lanarkshire"
        },
        {
            "id": "North Lincolnshire",
            "value": "North Lincolnshire"
        },
        {
            "id": "North Somerset",
            "value": "North Somerset"
        },
        {
            "id": "North Tyneside",
            "value": "North Tyneside"
        },
        {
            "id": "North Yorkshire",
            "value": "North Yorkshire"
        },
        {
            "id": "Northamptonshire",
            "value": "Northamptonshire"
        },
        {
            "id": "Northumberland",
            "value": "Northumberland"
        },
        {
            "id": "Nottingham",
            "value": "Nottingham"
        },
        {
            "id": "Nottinghamshire",
            "value": "Nottinghamshire"
        },
        {
            "id": "Oldham",
            "value": "Oldham"
        },
        {
            "id": "Orkney Islands",
            "value": "Orkney Islands"
        },
        {
            "id": "Oxfordshire",
            "value": "Oxfordshire"
        },
        {
            "id": "Pembrokeshire",
            "value": "Pembrokeshire"
        },
        {
            "id": "Perth and Kinross",
            "value": "Perth and Kinross"
        },
        {
            "id": "Peterborough",
            "value": "Peterborough"
        },
        {
            "id": "Plymouth",
            "value": "Plymouth"
        },
        {
            "id": "Poole",
            "value": "Poole"
        },
        {
            "id": "Portsmouth",
            "value": "Portsmouth"
        },
        {
            "id": "Powys",
            "value": "Powys"
        },
        {
            "id": "Reading",
            "value": "Reading"
        },
        {
            "id": "Redbridge",
            "value": "Redbridge"
        },
        {
            "id": "Redcar and Cleveland",
            "value": "Redcar and Cleveland"
        },
        {
            "id": "Renfrewshire",
            "value": "Renfrewshire"
        },
        {
            "id": "Rhondda, Cynon, Taff",
            "value": "Rhondda, Cynon, Taff"
        },
        {
            "id": "Richmond upon Thames",
            "value": "Richmond upon Thames"
        },
        {
            "id": "Rochdale",
            "value": "Rochdale"
        },
        {
            "id": "Rotherham",
            "value": "Rotherham"
        },
        {
            "id": "Rutland",
            "value": "Rutland"
        },
        {
            "id": "St. Helens",
            "value": "St. Helens"
        },
        {
            "id": "Salford",
            "value": "Salford"
        },
        {
            "id": "Sandwell",
            "value": "Sandwell"
        },
        {
            "id": "Scottish Borders, The",
            "value": "Scottish Borders, The"
        },
        {
            "id": "Sefton",
            "value": "Sefton"
        },
        {
            "id": "Sheffield",
            "value": "Sheffield"
        },
        {
            "id": "Shetland Islands",
            "value": "Shetland Islands"
        },
        {
            "id": "Shropshire",
            "value": "Shropshire"
        },
        {
            "id": "Slough",
            "value": "Slough"
        },
        {
            "id": "Solihull",
            "value": "Solihull"
        },
        {
            "id": "Somerset",
            "value": "Somerset"
        },
        {
            "id": "South Ayrshire",
            "value": "South Ayrshire"
        },
        {
            "id": "South Gloucestershire",
            "value": "South Gloucestershire"
        },
        {
            "id": "South Lanarkshire",
            "value": "South Lanarkshire"
        },
        {
            "id": "South Tyneside",
            "value": "South Tyneside"
        },
        {
            "id": "Southampton",
            "value": "Southampton"
        },
        {
            "id": "Southend-on-Sea",
            "value": "Southend-on-Sea"
        },
        {
            "id": "Southwark",
            "value": "Southwark"
        },
        {
            "id": "Staffordshire",
            "value": "Staffordshire"
        },
        {
            "id": "Stirling",
            "value": "Stirling"
        },
        {
            "id": "Stockport",
            "value": "Stockport"
        },
        {
            "id": "Stockton-on-Tees",
            "value": "Stockton-on-Tees"
        },
        {
            "id": "Stoke-on-Trent",
            "value": "Stoke-on-Trent"
        },
        {
            "id": "Suffolk",
            "value": "Suffolk"
        },
        {
            "id": "Sunderland",
            "value": "Sunderland"
        },
        {
            "id": "Surrey",
            "value": "Surrey"
        },
        {
            "id": "Sutton",
            "value": "Sutton"
        },
        {
            "id": "Swansea",
            "value": "Swansea"
        },
        {
            "id": "Swindon",
            "value": "Swindon"
        },
        {
            "id": "Tameside",
            "value": "Tameside"
        },
        {
            "id": "Telford and Wrekin",
            "value": "Telford and Wrekin"
        },
        {
            "id": "Thurrock",
            "value": "Thurrock"
        },
        {
            "id": "Torbay",
            "value": "Torbay"
        },
        {
            "id": "Torfaen",
            "value": "Torfaen"
        },
        {
            "id": "Tower Hamlets",
            "value": "Tower Hamlets"
        },
        {
            "id": "Trafford",
            "value": "Trafford"
        },
        {
            "id": "Vale of Glamorgan, The",
            "value": "Vale of Glamorgan, The"
        },
        {
            "id": "Wakefield",
            "value": "Wakefield"
        },
        {
            "id": "Walsall",
            "value": "Walsall"
        },
        {
            "id": "Waltham Forest",
            "value": "Waltham Forest"
        },
        {
            "id": "Wandsworth",
            "value": "Wandsworth"
        },
        {
            "id": "Warrington",
            "value": "Warrington"
        },
        {
            "id": "Warwickshire",
            "value": "Warwickshire"
        },
        {
            "id": "West Berkshire",
            "value": "West Berkshire"
        },
        {
            "id": "West Dunbartonshire",
            "value": "West Dunbartonshire"
        },
        {
            "id": "West Lothian",
            "value": "West Lothian"
        },
        {
            "id": "West Sussex",
            "value": "West Sussex"
        },
        {
            "id": "Westminster",
            "value": "Westminster"
        },
        {
            "id": "Wigan",
            "value": "Wigan"
        },
        {
            "id": "Wiltshire",
            "value": "Wiltshire"
        },
        {
            "id": "Windsor and Maidenhead",
            "value": "Windsor and Maidenhead"
        },
        {
            "id": "Wirral",
            "value": "Wirral"
        },
        {
            "id": "Wokingham",
            "value": "Wokingham"
        },
        {
            "id": "Wolverhampton",
            "value": "Wolverhampton"
        },
        {
            "id": "Worcestershire",
            "value": "Worcestershire"
        },
        {
            "id": "Wrexham",
            "value": "Wrexham"
        },
        {
            "id": "York",
            "value": "York"
        }
    ]
}



// WEBPACK FOOTER //
// ./src/modules/store/component/form/region-list.js